module.exports = __webpack_public_path__ + "img/logo_BBE_avatar.4a7c9fb2.png";